// extracted by mini-css-extract-plugin
export default {"root":"AssessmentEyebrow_root__eRZGh","label":"AssessmentEyebrow_label__vWZO5","rule":"AssessmentEyebrow_rule__RUWtg","light":"AssessmentEyebrow_light__kvVj+"};